/* LUMINAIRE EUROPE — commutateur jour/nuit + allume/eteint
   Modele Mod Lighting : commandes posees DANS la premiere slide du media,
   alignees avec le bouton 3D. Custom element : se reinitialise tout seul a
   chaque insertion dans le DOM, y compris lors de la navigation "morphing"
   du theme, ou les <script> inline ne sont pas rejoues. */

if (!customElements.get('lm-light-switcher')) {
  class LmLightSwitcher extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.light = true;
      this.night = false;
      this.hasSelection = false;
      this.applyVersion = 0;
      this.originals = null;
      this.lastTarget = null;

      this.imgs = {
        dayoff: this.dataset.imgDayOff || '',
        dayon: this.dataset.imgDayOn || '',
        nightoff: this.dataset.imgNightOff || '',
        nighton: this.dataset.imgNightOn || '',
      };
      /* Slides ou la barre s'affiche (numeros 1 = premiere image), choisies par produit. Defaut : 1 et 2. */
      const liste = (this.dataset.slides || '').split(',')
        .map(function (s) { return parseInt(s, 10); })
        .filter(function (n) { return n > 0; });
      this.slidesOk = liste.length ? liste : [1, 2];

      this.gallery = this.findGallery();
      if (!this.gallery) {
        this.style.display = 'none';
        return;
      }

      this.mount();
      if (!this.toolbar) return;
      this.bindControls();
      this.syncLabels();
      this.watchFirstSlide();
      this.markFirst();
      this.cale();
      this.etatInitial();
      const recale = () => this.cale();
      window.addEventListener('resize', recale);
      window.addEventListener('scroll', recale, { passive: true });
      [200, 800, 2000].forEach((d) => setTimeout(recale, d));
    }

    /* Au chargement, la galerie conserve sa propre image. Apres le premier clic,
       chaque combinaison affiche son metafield, y compris « jour, allume ». */
    etatInitial() {
      // Regle Ross 26 : meme un ancien reglage ne remplace pas la galerie sans clic.
      this.resetSelection();
    }

    resetSelection() {
      this.applyVersion += 1;
      this.hasSelection = false;
      this.light = true;
      this.night = false;
      this.lastTarget = null;
      this.syncLabels();
    }

    /* Cale la barre sur le bas (ou le haut) de la premiere image, la galerie incluant aussi les vignettes. */
    cale() {
      if (!this.toolbar || this.dataset.ancrage !== 'bas') return;
      const img = this.gallery.querySelector('img');
      if (!img) return;
      const gi = this.gallery.getBoundingClientRect();
      const ii = img.getBoundingClientRect();
      if (!ii.height) return;
      const marge = parseInt(this.dataset.marge || '16', 10);
      this.toolbar.style.top = 'auto';
      this.toolbar.style.bottom = Math.max(0, Math.round(gi.bottom - ii.bottom + marge)) + 'px';
    }

    /* Garde, dans l'ordre de la galerie, les slides dont le numero est choisi pour ce produit. */
    slidesChoisies(liste) {
      const ok = this.slidesOk || [1, 2];
      return liste.filter(function (s, i) { return ok.indexOf(i + 1) !== -1; });
    }

    findGallery() {
      return (
        document.querySelector('media-gallery') ||
        document.querySelector('.product-media-container') ||
        document.querySelector('.product__media-list')
      );
    }

    /* Barre d'outils partagee, posee en haut a gauche du media.
       Le bouton 3D y est rapatrie pour un alignement parfait. */
    mount() {
      /* La barre s'ancre au conteneur de la PREMIERE IMAGE (pas a toute la galerie : sinon « en bas »
         tombe sous les vignettes). Repli sur la galerie si la structure du theme change. */
      /* La barre reste enfant de la GALERIE : le conteneur de l'image ouvre la visionneuse au clic,
         y placer la barre rendait les boutons inutilisables. Le calage bas est calcule en JS. */
      const g = this.gallery;
      if (getComputedStyle(g).position === 'static') g.style.position = 'relative';

      let bar = g.querySelector('.lm-media-toolbar');
      /* Le bloc peut etre rendu deux fois (mise en page mobile + bureau) : une seule instance pilote la barre. */
      if (bar && bar.querySelector('lm-light-switcher') && bar.querySelector('lm-light-switcher') !== this) {
        this.toolbar = null;
        this.remove();
        return;
      }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'lm-media-toolbar';
      }
      if (bar.parentElement !== g) g.appendChild(bar);
      /* Aucun clic ne doit atteindre la slide (sinon : ouverture de la visionneuse plein ecran). */
      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((ev) => {
        bar.addEventListener(ev, function (e) { e.stopPropagation(); });
      });
      this.toolbar = bar;
      bar.appendChild(this);

      if (this.dataset.adopter3d === 'true') {
        this.adopt3dButton();
        setTimeout(() => this.adopt3dButton(), 400);
        setTimeout(() => this.adopt3dButton(), 1200);
      }
    }

    adopt3dButton() {
      const btn = document.querySelector('[data-v3d-open]');
      if (!btn || btn.parentElement === this.toolbar) return;
      btn.style.position = 'static';
      btn.style.top = 'auto';
      btn.style.left = 'auto';
      btn.style.right = 'auto';
      btn.style.bottom = 'auto';
      this.toolbar.insertBefore(btn, this.toolbar.firstChild);
      this.markFirst();
    }

    /* Le premier segment ne porte pas de trait separateur. */
    markFirst() {
      if (!this.toolbar) return;
      const segs = this.toolbar.querySelectorAll('button');
      segs.forEach(function (b, i) {
        b.classList.toggle('lm-first', i === 0);
      });
    }

    bindControls() {
      const self = this;
      this.querySelectorAll('[data-lm-toggle]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const which = el.getAttribute('data-lm-toggle');
          /* Style commutateur : ON et OFF sont deux zones du meme bouton, chacune fixe l'etat (pas de bascule). */
          const zone = e.target.closest ? e.target.closest('[data-lm-set]') : null;
          if (which === 'light' && zone) {
            const voulu = zone.getAttribute('data-lm-set') === 'on';
            if (!self.hasSelection) self.night = false;
            self.light = voulu;
            self.hasSelection = true;
            self.apply();
            return;
          }
          if (!self.hasSelection) {
            self.light = true;
            self.night = which === 'night';
          } else {
            if (which === 'light') self.light = !self.light;
            if (which === 'night') self.night = !self.night;
          }
          self.hasSelection = true;
          self.apply();
        });
      });
    }

    syncLabels() {
      const self = this;
      this.querySelectorAll('[data-lm-toggle]').forEach(function (el) {
        const which = el.getAttribute('data-lm-toggle');
        const on = which === 'light' ? self.light : self.night;
        el.classList.toggle('is-on', self.hasSelection && on);
        el.setAttribute('data-lm-etat', on ? 'on' : 'off');
        if (self.hasSelection) el.setAttribute('aria-pressed', String(on));
        else el.removeAttribute('aria-pressed');
        const out = el.querySelector('[data-lm-value]');
        if (out) out.textContent = self.hasSelection
          ? el.getAttribute(on ? 'data-label-on' : 'data-label-off') || ''
          : el.getAttribute('data-label-initial') || (which === 'light' ? 'Allumer' : 'Voir la nuit');
        el.querySelectorAll('[data-lm-icon]').forEach(function (ic) {
          ic.hidden = ic.getAttribute('data-lm-icon') !== (!self.hasSelection || on ? 'on' : 'off');
        });
      });
    }

    /* Les commandes n'ont de sens que sur la premiere image : on les masque
       des qu'elle sort de l'ecran (swipe vers une autre vue, ou scroll). */
    /* La barre (et le bouton 3D) ne concernent que les 2 PREMIERES slides.
       Carrousel : la slide courante porte aria-hidden="false" — on l'ecoute. Grille : on retombe sur l'ecran. */
    watchFirstSlide() {
      const self = this;
      const g = this.gallery;
      const cibles = function () {
        const t = [self.toolbar];
        const b3d = document.querySelector('[data-v3d-open]');
        if (b3d) t.push(b3d);
        return t.filter(Boolean);
      };
      /* Style pose EN DIRECT : la feuille du theme n'applique pas toujours nos classes (cascade/couches).
         Les classes restent posees pour la transition et pour d'eventuels styles du theme. */
      const montre = function (visible) {
        cibles().forEach(function (el) {
          el.classList.toggle('is-away', !visible);
          el.classList.toggle('lm-away', !visible);
          el.style.transition = 'opacity .25s ease, visibility .25s ease';
          el.style.opacity = visible ? '' : '0';
          el.style.visibility = visible ? '' : 'hidden';
          el.style.pointerEvents = visible ? '' : 'none';
        });
      };

      const slides = Array.prototype.slice.call(g.querySelectorAll('slideshow-slide'));
      if (slides.length) {
        /* Regle geometrique, independante du mecanisme du theme (scroll, transform ou aria) :
           la barre reste visible tant qu'une des DEUX PREMIERES slides occupe la fenetre du carrousel. */
        const piste = slides[0].parentElement || g;
        const fenetre = piste.parentElement || piste;
        const deux = self.slidesChoisies(slides);
        /* Un seul calcul par image affichee (les evenements de defilement sont regroupes), et aucun style
           reecrit tant que l'etat visible/masque ne change pas : le navigateur reste libre pour animer. */
        let attente = 0, dernierVisible = null;
        const evalue = function () { if (!attente) attente = requestAnimationFrame(evalueMaintenant); };
        const evalueMaintenant = function () {
          attente = 0;
          const p = fenetre.getBoundingClientRect();
          let visible = false;
          deux.forEach(function (s) {
            const b = s.getBoundingClientRect();
            if (!b.width) return;
            const chevauche = Math.min(b.right, p.right) - Math.max(b.left, p.left);
            if (chevauche > b.width * 0.5) visible = true;
          });
          const courante = self.imageCourante();
          if (self.lastTarget && (!visible || courante !== self.lastTarget)) {
            self.restoreOriginal(self.lastTarget);
            self.resetSelection();
          }
          if (visible !== dernierVisible) { dernierVisible = visible; montre(visible); }
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(evalue, { root: fenetre, threshold: [0, 0.5, 1] });
          deux.forEach(function (s) { io.observe(s); });
        }
        if ('MutationObserver' in window) {
          const mo = new MutationObserver(evalue);
          slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'style'] }); });
          mo.observe(piste, { attributes: true, attributeFilter: ['style', 'class'] });   // le theme translate souvent la piste
        }
        piste.addEventListener('scroll', evalue, { passive: true });
        g.addEventListener('scroll', evalue, { passive: true, capture: true });
        window.addEventListener('resize', evalue);
        evalue();
        [300, 1200, 3000].forEach(function (ms) { setTimeout(evalue, ms); });
        /* Filet : certains themes deplacent les slides sans emettre d'evenement observable.
           On relit les positions 3 fois par seconde, uniquement quand la galerie est a l'ecran. */
        let aLEcran = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (e) { aLEcran = e[0].isIntersecting; }, { threshold: 0 }).observe(g);
        }
        setInterval(function () {
          if (aLEcran) evalue();
        }, 350);
        return;
      }

      if (!('IntersectionObserver' in window)) return;
      const images = this.slidesChoisies(Array.prototype.slice.call(g.querySelectorAll('img')));
      if (!images.length) return;
      const vus = new Map();
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { vus.set(en.target, en.isIntersecting); });
        let visible = false;
        vus.forEach(function (v) { if (v) visible = true; });
        montre(visible);
      }, { threshold: 0.25 });
      images.forEach(function (im) { io.observe(im); });
    }

    /* L'image a remplacer est celle de la slide REELLEMENT affichee (slide 1 ou 2) : sur la slide 2,
       remplacer l'image de la slide 1 ne se voyait pas — les boutons paraissaient inertes. */
    imageCourante() {
      const g = this.gallery;
      const slides = this.slidesChoisies(Array.prototype.slice.call(g.querySelectorAll('slideshow-slide')));
      if (slides.length) {
        const piste = slides[0].parentElement || g;
        const fenetre = piste.parentElement || piste;   // la piste se deplace avec ses slides quand le theme la translate
        const p = fenetre.getBoundingClientRect();
        for (let i = 0; i < slides.length; i++) {
          const b = slides[i].getBoundingClientRect();
          if (!b.width) continue;
          const chevauche = Math.min(b.right, p.right) - Math.max(b.left, p.left);
          if (chevauche > b.width * 0.5) {
            const im = slides[i].querySelector('img');
            if (im) return im;
          }
        }
        const premiere = slides.length ? slides[0].querySelector('img') : null;
        if (premiere) return premiere;
      }
      return g.querySelector('img');
    }

    targetImages() {
      const im = this.imageCourante();
      return im ? [im] : [];
    }

    currentKey() {
      return (this.night ? 'night' : 'day') + (this.light ? 'on' : 'off');
    }

    restoreOriginal(img) {
      if (!img || !this.originals) return;
      const o = this.originals.find(function (x) { return x.img === img; });
      if (!o) return;
      if (o.srcset) img.setAttribute('srcset', o.srcset); else img.removeAttribute('srcset');
      if (o.sizes) img.setAttribute('sizes', o.sizes); else img.removeAttribute('sizes');
      if (o.src) img.setAttribute('src', o.src);
      img.style.opacity = '1';
    }

    apply() {
      const targets = this.targetImages();
      if (!targets.length) { this.resetSelection(); return; }

      if (!this.originals) this.originals = [];
      const self = this;
      targets.forEach(function (img) {
        const connu = self.originals.some(function (o) { return o.img === img; });
        if (!connu) self.originals.push({
          img: img,
          src: img.getAttribute('src'),
          srcset: img.getAttribute('srcset'),
          sizes: img.getAttribute('sizes')
        });
        self.lastTarget = img;
      });

      const key = this.currentKey();
      // Un autre etat ne peut pas servir de repli sous une etiquette incorrecte.
      const url = this.imgs[key];
      if (!url) {
        targets.forEach((img) => this.restoreOriginal(img));
        this.resetSelection();
        return;
      }
      const version = ++this.applyVersion;

      targets.forEach((img) => {
        img.style.transition = 'opacity .2s ease';
        img.style.opacity = '0.45';
        setTimeout(() => {
          if (version !== this.applyVersion || this.lastTarget !== img) return;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', url);
          img.style.opacity = '1';
          this.syncLabels();
        }, 110);
      });
    }
  }

  customElements.define('lm-light-switcher', LmLightSwitcher);
}
